
import {
  openNoAddressPop,
  formatWareImgUrl,
  noAddressCheck,
  getStockMax,
  getDeliveryMethod,
  priceFormatOther
} from "../../utils/utils"
import { handleAddToCartV2 } from "../../utils/cartResponse"
import inputNumber from "@/components/cms/inputNumber.vue"
import emptyImg from "@/assets/images/empty_img.png"
import lazyImg from "@/components/cms/lazyImg.vue"
import { trackAddToCart, trackSelectItem, handleChangeCartNumber } from "@/utils/track"

export default {
  name: "CmsWare",
  components: {
    inputNumber,
    lazyImg
  },
  props: {
    configData: {
      type: Object,
      default: () => {}
    },
    styleConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      configs: {},
      commonReqParams: {},
      deliveryMethod: "homeDelivery"
    }
  },
  computed: {
    imageUrl() {
      const imgUrl = this.configs.spImgUrl
      if (imgUrl) {
        return formatWareImgUrl(imgUrl)
      }
      return emptyImg
    },
    detailLink() {
      const { skuId, sku, name } = this.configs?.additional || {}
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${skuId || sku}&name=${encodeURIComponent(
        name
      )}`
    },
    findSimilarLink() {
      const { skuId, sku } = this.configs?.additional || {}
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?skuId=${skuId || sku}`
    }
  },
  watch: {
    configData: {
      handler(newVal) {
        // 聚合首页下发商品携带门店商家
        if (newVal?.venderId && newVal?.storeId) {
          newVal.additional.venderId = newVal.venderId
          newVal.additional.storeId = newVal.storeId
        }
        this.configs = newVal
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    this.deliveryMethod = getDeliveryMethod()
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
  },
  mounted() {
    const sku = this.configs?.additional.sku || this.configs?.additional.skuId
    this.$bus.$off(`rest_${sku}_count`, this.handleRestCout)
    this.$bus.$on(`rest_${sku}_count`, this.handleRestCout)
  },
  beforeDestroy() {
    const sku = this.configs?.additional.sku || this.configs?.additional.skuId
    this.$bus.$off(`rest_${sku}_count`, this.handleRestCout)
  },
  methods: {
    handleRestCout(count) {
      this.$nextTick(() => {
        this.$set(this.configs, "addCartCount", count)
      })
    },
    async handleAddClick(item) {
      if (noAddressCheck()) {
        openNoAddressPop()
        return
      }

      trackAddToCart(item)
      const [error, data, wareList] = await handleAddToCartV2({
        // TODO storeId
        venderId: this.configs.venderId,
        storeId: this.configs.storeId || this.commonReqParams.storeId,
        wares: [{ sku: item.additional.sku || item.additional.skuId, beforeCount: 0, count: 1, checked: 1 }],
        sort: 1
      })
      if (data) {
        const res = data
        this.$set(this.configs, "addCartCount", 1)
        const sku = item.additional.sku || item.additional.skuId
        const Obj = wareList.find(item => item.sku === sku) || {}
        this.$set(this.configs, "stock", Obj.stock)
        // 同步相同sku商品加购数量
        this.$bus.$emit(`rest_${sku}_count`, 1)
      } else {
        this.$set(this.configs, "addCartCount", 0)
        console.log("加购失败", error)
        if (error && error.code == "44999") {
          openNoAddressPop()
        }
      }
    },
    handleNumChange(count, item) {
      handleChangeCartNumber(count, this.configs.addCartCount, item)
      const sku = item.additional.sku || item.additional.skuId
      const cocunt = count <= 0 ? 0 : count
      // 同步相同sku商品加购数量
      this.$bus.$emit(`rest_${sku}_count`, cocunt)
    },
    goDetail(configs) {
      const { venderId, storeId } = configs
      if (venderId && storeId) {
        this.$cookies.set("store", storeId)
        this.$cookies.set("venderId", venderId)
      }
      this.trackSelectItem(configs)
    },
    trackSelectItem,
    getStockMax,
    priceFormatOther
  }
}
